import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/privacy')({
  head: () => {
    const p = getStaticPage('privacy');
    return staticHead({ pathname: '/privacy', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="privacy" />,
});
